export type HelperError = {
  helperName: string;
  message: string;
  suggestion?: string;
  position?: {
    line: number;
    column: number;
    endLine?: number;
    endColumn?: number;
  };
  args?: unknown[];
  severity: 'error' | 'warning' | 'info';
};

export class ErrorCollector {
  private errors: HelperError[] = [];

  add(
    error: Omit<HelperError, 'severity'> & {
      severity?: 'error' | 'warning' | 'info';
    }
  ): string {
    this.errors.push({
      severity: 'error',
      ...error,
    });
    return '';
  }

  getErrors(): HelperError[] {
    return this.errors;
  }

  hasErrors(): boolean {
    return this.errors.some((e) => e.severity === 'error');
  }

  clear(): void {
    this.errors = [];
  }
}
